import React, { useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Service from "./pages/Service";
import Research from "./pages/Research";
import Evaluation from "./pages/Evaluation";
import Events from "./pages/Events";
import AI4FinTech from "./pages/AI4FinTech";
import MarketGAN from './pages/MarketGAN';
import EarnHFT from "./pages/EarnHFT";
import MacroHFT from "./pages/MacroHFT";
import EarnMore from "./pages/EarnMore";
import Finagent from "./pages/Finagent";
import Latestwork from "./pages/hiddenpage";

export default function App() {
    const [sessionID, setSessionID] = useState("");
    const [optionSelected, setOptionSelected] = useState({
        task_name: "",
        dataset_name: "",
        optimizer_name: "",
        loss_name: "",
        agent_name: "",
        start_date: "",
        end_date: ""
    });

    // LayoutWrapper component to include Navbar and Footer
    const LayoutWrapper = ({ children }) => (
        <>
            <Navbar />
            {children}
            <Footer />
        </>
    );

    function TestPage() {
        console.log("TestPage rendered");
        return <div>This is Test Page</div>;
    }


    return (
        // <BrowserRouter>

    <Routes>
                <Route path="/" element={<LayoutWrapper children={<Home />} />} />
                <Route path="/contact" element={<LayoutWrapper children={<Contact />} />} />
                <Route path="/research" element={<LayoutWrapper children={<Research />} />} />
                <Route path="/about" element={<LayoutWrapper children={<About />} />} />
                <Route
                    path="/service"
                    element={
                        <LayoutWrapper
                            children={
                                <Service
                                    sessionID={sessionID}
                                    setSessionID={setSessionID}
                                    optionSelected={optionSelected}
                                    setOptionSelected={setOptionSelected}
                                />
                            }
                        />
                    }
                />
                <Route
                    path="/evaluation-toolbox"
                    element={
                        <LayoutWrapper
                            children={<Evaluation sessionID={sessionID} trainDatasetName={optionSelected.dataset_name} />}
                        />
                    }
                />
                <Route path="/events" element={<LayoutWrapper children={<Events />} />} />
                <Route path="/AAAI23_AI4FinTech" element={<AI4FinTech />} />
                <Route path="/EarnHFT" element={<LayoutWrapper children={<EarnHFT />} />} />
                <Route path="/MacroHFT" element={<LayoutWrapper children={<MacroHFT />} />} />
                <Route path="/Latestwork" element={<LayoutWrapper children={<Latestwork />} />} />
                <Route path="/EarnMore" element={<LayoutWrapper children={<EarnMore />} />} />
                <Route path="/Finagent" element={<LayoutWrapper children={<Finagent />} />} />
                <Route path="/marketgan" element={<LayoutWrapper children={<MarketGAN sessionID={sessionID} />} />} />
        <Route path="/connect_test" element={<TestPage />} />


    </Routes>
        // </BrowserRouter>
    );
}

